import { render } from "./edit.vue?vue&type=template&id=6f9f4123&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=6f9f4123&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6f9f4123"

export default script